import React from 'react';

const Splash=()=>{
    return (
        <div className='Splash'>
            <img src='/menu-logo.png' alt='Logo' className='splash-logo'/>
        </div>
    );
};

export default Splash;
